// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderUploadStyles } from "@insite/content-library/Components/OrderUpload";
import { FormFieldStyle } from "@tps/MobiusOverrides/FormField";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

orderUploadStyles.downloadTemplateButton = {
    variant: "secondary",
    css: css`
        margin-bottom: 15px;
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

orderUploadStyles.fileUploader = {
    buttonProps: {
        variant: "secondary",
        css: css`
            ${xScreen("lte", "xs")} {
                margin-left: 0;
                display: flex;
            }
        `,
    },
};

orderUploadStyles.includeFirstRowCheckbox = {
    css: css`
        margin: 15px 0;
        display: block;
    `,
    iconProps: {
        css: css`
            vertical-align: middle;
        `,
    },
};

orderUploadStyles.uploadFileButton = {
    css: css`
        float: right;
        margin-left: 15px;
        width: initial;
        ${xScreen("lte", "xs")} {
            margin: 0;
            margin-bottom: 10px;
            width: 100%;
        }
    `,
};

orderUploadStyles.mainWrapper = {
    css: css`
        width: 100%;
        div[class^="UploadWrapper"] {
            justify-content: space-between;
            ${FormFieldStyle} {
                max-width: 450px;
            }
        }
    `,
};

orderUploadStyles.spinner= {
    size: 12,
    css: css`
        margin-right: 8px;
    `,
}

orderUploadStyles.uploadFileButtonLabel = {
    size: 12,
    weight: "bold",
    css: css``,
};

orderUploadStyles.uploadingButtonLabel = {
    size: 12,
    weight: "bold",
    css: css`
        vertical-align: super;
    `,
};
